<div
  [style.background-color]="
    ticketSchedule.ticket.status == 'SOLD_OUT' ? '#F7F7FD' : ''
  "
  [style.padding-top]="
    ticketSchedule.ticket.status == 'SOLD_OUT' ? '0px' : '20px'
  "
  [style.border]="counter > 0 ? '1px solid black' : '1px solid #eaeaf1'"
  class="mb-4 ticket-card"
>
  <div
    *ngIf="ticketSchedule.ticket.status == 'SOLD_OUT'"
    class="d-flex justify-content-end"
  >
    <span
      class="soldout"
      [style.border-radius]="
        translate.currentLang == 'ar' ? '16px 0px' : '0px 16px'
      "
    >
      {{ "soldout" | translate }}
    </span>
  </div>
  <div class="d-flex justify-content-between px-4" style="align-items: center">
    <div
      (click)="
        ticketSchedule.ticket.status !== 'SOLD_OUT'
          ? (ticketExpanded = !ticketExpanded)
          : null
      "
      class="d-flex align-items-center flex-1 justify-content-between mobile-ticket-details"
    >
      <div class="d-flex align-items-center">
        <img
          src="/assets/images/icons/arrow-down.svg"
          *ngIf="!ticketExpanded"
          class="arrow"
          [style.opacity]="
            ticketSchedule.ticket.status == 'SOLD_OUT' ? '0.4' : ''
          "
        />
        <img
          src="/assets/images/icons/arrow-up.svg"
          *ngIf="ticketExpanded"
          class="arrow"
          [style.opacity]="
            ticketSchedule.ticket.status == 'SOLD_OUT' ? '0.4' : ''
          "
        />

        <div>
          <p
            class="title-ticket px-2 mb-0"
            [style.opacity]="
              ticketSchedule.ticket.status == 'SOLD_OUT' ? '0.4' : ''
            "
          >
            {{ helpers.getElementTranslatedName(ticketSchedule.ticket) }}
          </p>
          <p
            class="price-ticket-mobile mb-0"
            [style.opacity]="
              ticketSchedule.ticket.status == 'SOLD_OUT' ? '0.4' : ''
            "
          >
            <ng-container *ngIf="ticketSchedule.ticket.price !== 0">
              <span
                [innerHTML]="
                  ticketSchedule.ticket.price
                    | toVat
                    | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
                "
              ></span>
            </ng-container>
            <ng-container *ngIf="ticketSchedule.ticket.price === 0">
              {{ "free" | translate }}
            </ng-container>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <p
        class="price-ticket mb-0"
        *ngIf="!isMobile"
        [style.opacity]="
          ticketSchedule.ticket.status == 'SOLD_OUT' ? '0.4' : ''
        "
      >
        <ng-container *ngIf="ticketSchedule.ticket.price !== 0">
          <span
            [innerHTML]="
              ticketSchedule.ticket.price
                | toVat
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
            "
          ></span>
        </ng-container>
        <ng-container *ngIf="ticketSchedule.ticket.price === 0">
          {{ "free" | translate }}
        </ng-container>
      </p>

      <div class="d-flex gap-1 align-items-center">
        <button
          class="btn round-btn plus"
          (click)="increaseCount()"
          [disabled]="
            !increaseCountEnabled() ||
            ticketSchedule.ticket.status == 'SOLD_OUT'
          "
          [style.background-color]="
            ticketSchedule.ticket.status == 'SOLD_OUT' ? 'transparent' : ''
          "
        >
          <i class="fa fa-plus"></i>
        </button>
        <button
          disabled
          class="btn round-btn"
          style="color: #555770; font-size: 18px"
        >
          {{ counter }}
        </button>
        <button
          class="btn round-btn minus"
          (click)="decreaseCount()"
          [disabled]="
            !decreaseCountEnabled() ||
            ticketSchedule.ticket.status == 'SOLD_OUT'
          "
          [style.background-color]="
            ticketSchedule.ticket.status == 'SOLD_OUT' ? 'transparent' : ''
          "
        >
          <i class="fa fa-minus"></i>
        </button>
        <img
          (click)="deleteItem()"
          *ngIf="counter > 0 && isMobile"
          src="assets/images/icons/trash-red.svg"
          style="height: 20px; width: 20px"
        />
      </div>
    </div>
  </div>
  <div *ngIf="ticketExpanded" class="px-4">
    <p class="descr-ticket">
      {{ helpers.getElementTranslatedDescBase(ticketSchedule.ticket) }}
    </p>
  </div>
</div>
